export default "__VITE_ASSET__DC3j$ps6__"